import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getAllCategory: builder.mutation({
            query: (body) => ({
                url: `category/getAllCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addCategory: builder.mutation({
            query: (body) => ({
                url: `category/addCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getCategory: builder.mutation({
            query: (body) => ({
                url: `category/getCategoryById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateCategory: builder.mutation({
            query: (body) => ({
                url: `category/updateCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        })
    })
})

export const { useAddCategoryMutation, useGetAllCategoryMutation, useGetCategoryMutation, useUpdateCategoryMutation } = Api
